import type { ReactNode } from "react";
import { createUseStyles } from "react-jss";
import type { VetBoatsTheme } from "../../theme";
import { BrandMark } from "../brand/BrandMark";
import { SiteFooter } from "../layout/SiteFooter";

const useStyles = createUseStyles((theme: VetBoatsTheme) => ({
  page: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    boxSizing: "border-box",
    background: `linear-gradient(160deg, ${theme.color.primary} 0%, #2b4c7e 55%, ${theme.color.background} 55%)`,
  },
  panel: {
    width: "100%",
    background: theme.color.surface,
    borderRadius: 12,
    boxShadow: "0 12px 32px rgba(16, 24, 40, 0.18)",
    padding: 28,
    boxSizing: "border-box",
    [theme.narrow]: { padding: 20 },
  },
  brand: { marginBottom: 6 },
  tagline: { margin: "0 0 22px", color: theme.color.muted },
}));

export const AuthLayout = ({
  width,
  children,
}: {
  width: number;
  children: ReactNode;
}) => {
  const classes = useStyles();
  return (
    <main className={classes.page}>
      <div className={classes.panel} style={{ maxWidth: width }}>
        <div className={classes.brand}>
          <BrandMark tone="onLight" size="large" as="h1" />
        </div>
        <p className={classes.tagline}>Donated boat time for veterans</p>
        {children}
      </div>
      <SiteFooter boxed />
    </main>
  );
};
